import { SET_PUBLIC_DATA_ASSETS_COUNT, SET_USERS_DASHBOARD_DATA } from "../DataGuard/Utility/DataguardConstant";
import {
  SET_ALL_DATA_TAG_SOURCES,
  SET_DATA_ESTATE,
  SET_DATA_ESTATE_SUMMARY,
  SET_DATA_TAG_ALL_FILES,
  SET_DATA_TAG_DRIVES,
  SET_DATA_TAG_ACCESSIBILITY,
  SET_DATA_TAG_DUPLICATE_FILE_DATA,
  SET_DATA_TAG_FILE_CLASSIFICATIONS,
  SET_DATA_TAG_LOADING,
  SET_DATA_TAG_METADATA,
  SET_DATA_TAG_NODES_DATA,
  SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA,
  SET_DATA_TAG_USERS,
  SET_TOTAL_DATA_TAG_FILES,
  SET_SEARCHED_DATA_TAG_FILES,
  SET_SEARCHED_DATA_TAG_USERS,
  SET_SIZE_CARD_DATA,
  SET_SENSITIVE_SUMMARY_CARD_DATA,
  SET_CATEGORY_CARD_DATA,
  DATA_ESTATE_SUMMARY_LOADER,
  SET_ALL_FILE_TYPE_LIST,
  SET_DATA_TAG_DUPLICATE_DRIVE_DATA,
  SET_DATA_TAG_DUPLICATE_USER_DATA,
  SET_DATA_TAG_DUPLICATE_USER_DATA_2,
  SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA,
  SET_DATA_TAG_POPUP_LOADER,
  SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2,
  SET_FILE_MAP_DATA,
  SET_USERS_LIST,
  SET_FILES_LIST,
  SET_IS_DATABASE,
  SET_IS_APPLICATION,
  SET_IS_FILE_SYSTEM,
  SET_SELECTED_DATA_TAG_SOURCE_ID,
  SET_DATA_SOURCES_DATA_TAG,
  SET_DATA_ESTATE_SUMMARY_TAB,
  DATA_ESTATE_SUMMARY_TAB_LOADER,
  SET_DATA_ESTATE_COVERAGE_CARD,
  SET_DATA_ESTATE_OVERVIEW,
  SET_TAG_FILES_STATUS,
  REFRESH_DATA_TAG_ALL_FILES,
  SET_TAG_FILES_SELECTION,
  SET_TAG_FILES_SELECT_MODE,
} from "./DataTagConstants";

const initialState = {
  totalFiles: 0,
  dataEstate: [],
  fileClassification: [],
  sensitiveAndRegulated: {},
  duplicateFileData: {},
  metadata: {},
  dataAccessibility: {},
  loading: false,
  nodesData: [],
  allDataSources: [],
  allFiles: {
    content: [],
    totalCount: 0,
  },
  users: {
    content: [],
    totalCount: 0,
  },
  drives: [],
  selectedDataSource: null,
  dataEstateSummary: {},
  searchedListFiles: [],
  searchedDataTagUsers: [],
  sizeCardData: {
    size: 0,
    pda: 0,
    sensitiveData: 0,
    Total: 0
  },
  sensitiveCardData: {
    sensitiveData: [],
    total: 0,
    fileClassificationStatus: []
  }, 
  categoryCardData: [],
  summaryLoader: false,
  fileTypesList: [],
  duplicateDriveData: [],
  duplicateUserData: [],
  duplicateUserData2: [],
  duplicateDriveFileData: [],
  popupLoader: false,
  duplicateFileData2: [],
  fileMapData: [],
  usersList: [],
  filesList: [],
  publicDataAssetsCount: {},
  userDashboardData: {},
  isDatabase: false,
  isApplication: false,
  isFileSystem: false,
  dataSourcesDataTag: [],
  dataEstateSummaryTab: {},
  dataEstateSummaryTabLoader: false,
  dataEstateCoverageCard: [],
  dataEstateOverview: {},
  tagFilesStatus: { loading: false, status: "idle", message: "" },
  tagRefreshKey: 0,
  // what the user picked in the Tag Files window (fileIds are ticked in the All Files table)
  tagFilesSelection: { sensitivities: [], categories: [], regulations: [], fileIds: [] },
  // true while the All Files table shows checkboxes for picking files to tag
  tagFilesSelectMode: false,
};

export default function dataTagReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOTAL_DATA_TAG_FILES:
      return {
        ...state,
        totalFiles: action.payload,
      };
    case SET_DATA_ESTATE:
      return {
        ...state,
        dataEstate: action.payload,
      };
    case SET_DATA_TAG_FILE_CLASSIFICATIONS: {
      return {
        ...state,
        fileClassification: action.payload,
      };
    }
    case SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA: {
      return {
        ...state,
        sensitiveAndRegulated: action.payload,
      };
    }
    case SET_DATA_TAG_DUPLICATE_FILE_DATA: {
      return {
        ...state,
        duplicateFileData: action.payload,
      };
    }
    case SET_DATA_TAG_METADATA: {
      return {
        ...state,
        metadata: action.payload,
      };
    }
    case SET_DATA_TAG_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_DATA_TAG_NODES_DATA:
      return {
        ...state,
        nodesData: action.payload,
      };
    case SET_DATA_TAG_ALL_FILES:
      return {
        ...state,
        allFiles: action.payload,
      };
    case SET_SELECTED_DATA_TAG_SOURCE_ID:
      return {
        ...state,
        selectedDataSource: action.payload,
      };
    case SET_ALL_DATA_TAG_SOURCES:
      return {
        ...state,
        allDataSources: action.payload,
      };
    case SET_DATA_TAG_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case SET_DATA_ESTATE_SUMMARY:
      return {
        ...state,
        dataEstateSummary: action.payload,
      };
    case SET_DATA_TAG_DRIVES:
      return {
        ...state,
        drives: action.payload,
      };
    case SET_DATA_TAG_ACCESSIBILITY: {
      return {
        ...state,
        dataAccessibility: action.payload,
      };
    };
    case SET_SEARCHED_DATA_TAG_FILES:
      return {
        ...state,
        searchedListFiles: action.payload,
      };
    case SET_SEARCHED_DATA_TAG_USERS:
      return {
        ...state,
        searchedDataTagUsers: action.payload,
      };
    case SET_SIZE_CARD_DATA:
      return {
        ...state,
        sizeCardData: action.payload
      }
    case SET_SENSITIVE_SUMMARY_CARD_DATA:
      return {
        ...state,
        sensitiveCardData: action.payload
      }
    case SET_CATEGORY_CARD_DATA: {
      return {
        ...state,
        categoryCardData: action.payload
      }
    }
    case SET_DATA_SOURCES_DATA_TAG: {
      return {
        ...state,
        dataSourcesDataTag: action.payload
      }
    }
    case DATA_ESTATE_SUMMARY_LOADER: {
      return {
        ...state,
        summaryLoader: action.payload
      }
    }
    case SET_ALL_FILE_TYPE_LIST: {
      return {
        ...state,
        fileTypesList: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_DRIVE_DATA: {
      return {
        ...state,
        duplicateDriveData: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_USER_DATA: {
      return {
        ...state,
        duplicateUserData: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_USER_DATA_2: {
      return {
        ...state,
        duplicateUserData2: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA: {
      return {
        ...state,
        duplicateDriveFileData: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2: {
      return {
        ...state,
        duplicateFileData2: action.payload
      }
    }
    case SET_FILE_MAP_DATA: {
      return {
        ...state,
        fileMapData: action.payload
      }
    }
    case SET_USERS_LIST: {
      return {
        ...state,
        usersList: action.payload
      }
    }
    case SET_DATA_TAG_POPUP_LOADER: {
      return {
        ...state,
        popupLoader: action.payload
      }
    }
    case SET_FILES_LIST: {
      return {
        ...state,
        filesList: action.payload
      }
    }
    case SET_PUBLIC_DATA_ASSETS_COUNT: {
      return {
        ...state,
        publicDataAssetsCount: action.payload
      }
    }

    case SET_USERS_DASHBOARD_DATA: {
      return {
        ...state,
        userDashboardData: action.payload
      }
    }
    case SET_IS_DATABASE: {
      return {
        ...state,
        isDatabase: action.payload
      }
    }
    case SET_IS_APPLICATION: {
      return {
        ...state,
        isApplication: action.payload
      }
    }
    case SET_IS_FILE_SYSTEM: {
      return {
        ...state,
        isFileSystem: action.payload
      }
    }
    case SET_DATA_ESTATE_SUMMARY_TAB: {
      return {
        ...state,
        dataEstateSummaryTab: action.payload
      }
    }
    case DATA_ESTATE_SUMMARY_TAB_LOADER: {
      return {
        ...state,
        dataEstateSummaryTabLoader: action.payload
      }
    }
    // Data Estate Coverage Card
    case SET_DATA_ESTATE_COVERAGE_CARD: {
      return {
        ...state,
        dataEstateCoverageCard: action.payload
      }
    }
    // Data Estate Overview (card2 .. card5)
    case SET_DATA_ESTATE_OVERVIEW: {
      return {
        ...state,
        dataEstateOverview: action.payload
      }
    }
    // Tag Files (NTFS)
    case SET_TAG_FILES_STATUS: {
      return {
        ...state,
        tagFilesStatus: action.payload
      }
    }
    case SET_TAG_FILES_SELECTION: {
      return {
        ...state,
        tagFilesSelection: action.payload
      }
    }
    case SET_TAG_FILES_SELECT_MODE: {
      return {
        ...state,
        tagFilesSelectMode: action.payload
      }
    }
    case REFRESH_DATA_TAG_ALL_FILES: {
      return {
        ...state,
        tagRefreshKey: state.tagRefreshKey + 1
      }
    }
    default:
      return state;
  }
}